module.exports = __webpack_public_path__ + "static/media/cogs.4073c905.svg";